module.exports = __webpack_public_path__ + "img/img_football_app1_en.e25e4f7e.png";